import {
  CaretDownOutlined,
  PlusCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Dropdown,
  Input,
  Menu,
  message,
  Modal,
  Select,
  Table,
} from "antd";
import Text from "antd/lib/typography/Text";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  companySetting,
  getCostCenterField,
  getCustomFields,
  getDesignations,
  getProjectsField,
  getRoles,
} from "../../../../actions/companySettings";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import endpoint from "../../../../config/Axios";
import { hasAccess, objectToFormData } from "../../../../utils";
import PageHeader from "../../../PageHeader";
import {
  AddEmployees,
  deleteEmployees,
  DeleteEmployees,
  employees,
  UpdateEmployees,
} from "./../../../../actions/employees";
import "./../../styles/setting.css";
import AddUsers from "./AddUser";
import UserDetails from "./UserDetails";
import AddCorporateForm from "./AddCorporateChecker";
// import DropdownIcon from "../../../../assets/icons/dropdown.png";
// import AddNewIcon from "../../../../assets/icons/add_new_white.png";
// import UploadIcon from "../../../../assets/icons/upload_users.png";

const { Search } = Input;

message.config({
  maxCount: 3,
});

const Users = ({ checker }) => {
  const employeesResponse = useSelector(
    (state) => state.employees.employees || {},
  );
  const deleteEmployeesResponse = useSelector(
    (state) => state.employees.deleteEmployees || {},
  );
  const addEmployeesResponse = useSelector(
    (state) => state.employees.addEmployees || {},
  );
  const updateEmployeesResponse = useSelector(
    (state) => state.employees.updateEmployees || {},
  );
  const searchRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { data: { total_records = 0 } = {}, success = false } =
    employeesResponse;
  const employeesRecord = checker
    ? employeesResponse?.data?.response?.checkers
    : employeesResponse?.data?.response?.employees;
  const [employeesData, setemployeesData] = React.useState([]);
  const [selectedId, setSelectedId] = React.useState("");
  const [search, setSearch] = React.useState("");
  const [showAddPage, setShowAddPage] = React.useState(false);
  const [clickedRecord, setClickedRecord] = React.useState("");
  const [showDetailsPage, setShowDetailsPage] = React.useState(false);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [data, setData] = useState([]);
  const [sum, setSum] = useState("");
  const [transfer, setTransfer] = useState(false);
  const [assignee, setAssignee] = useState(false);
  const [empId, setEmpId] = useState("");

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <div
          className={`d-flex align-center render_common_style status_${record?.status}`}
        >
          <div className="tableRowCircle mr1">
            {text ? text.charAt(0).toUpperCase() : "Z"}
          </div>
          <div className="ellipsis name" title={text}>
            {text}
          </div>
        </div>
      ),
    },
    checker
      ? false
      : {
          title: "Employee ID",
          dataIndex: "emp_id",
          key: "emp_id",
          render: (text) => (text ? text : ""),
          width: 150,
        },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Mobile No",
      dataIndex: "primary_phone",
      key: "primary_phone",
      width: 150,
    },
    {
      title: "Role",
      dataIndex: "roles",
      key: "roles",
      render: (data) => data.toString(),
    },
    checker
      ? false
      : {
          title: "Status",
          dataIndex: "status",
          key: "status",
          render: (text) => <div className={`tableStatus_${text}`}>{text}</div>,

          render: (text) => (
            <div className={`status status_${text}`}>
              {text?.replace(/_/g, " ")}
            </div>
          ),
        },
  ];

  const tableAction = [
    hasAccess("users_and_controls", "write")
      ? {
          title: "Actions",
          key: "action",
          fixed: "right",
          width: 110,
          render: (text, record) => (
            <div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  showEditModal(record.id);
                  // console.log("recorddd isss",record);
                }}
              >
                <img src={EditIcon} alt={"logo"} className="action-logo mr1" />
              </button>
              <button
                onClick={(e) => {
                  setSum(
                    record?.pending_approvals?.advances +
                      record?.pending_approvals?.trips +
                      record?.pending_approvals?.reports,
                  );
                  e.stopPropagation();
                  showDeleteModal(record.id);
                  let str = "";
                  let arr = record.roles;
                  arr.forEach((st, i) => {
                    if (st !== "Employee") {
                      // str = str + "role[" + i + "]=" + st + "&";
                      str = str + "role=" + st + "&";
                    }
                  });

                  endpoint
                    .get("/api/admin/employees/v1?" + str)
                    .then((response) => {
                      setData(
                        response?.data?.response?.employees
                          ?.filter((ele) => ele.id !== record.id)
                          .map((ele) => ({ label: ele.name, value: ele.id })),
                      );
                    });
                }}
              >
                <img src={DeleteIcon} alt={"logo"} className="action-logo" />
              </button>
            </div>
          ),
        }
      : {},
  ];

  React.useEffect(() => {
    dispatch(employees({ checkers: checker }));
    dispatch(getRoles({}));
    dispatch(getCustomFields({ is_enable: true }));
    dispatch(getDesignations());
    dispatch(getProjectsField({ is_enable: true }));
    dispatch(getCostCenterField({ is_enable: true }));
    dispatch(companySetting({}));
    // setIsModalVisible(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (success) {
      setemployeesData(employeesRecord);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeesResponse]);

  React.useEffect(() => {
    if (location.state && location.state?.openAddNew)
      setShowAddPage(location.state.openAddNew);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "", errors } = {} } =
      addEmployeesResponse;
    if (status) {
      setSelectedId("");
      setShowAddPage(false);
      setShowDetailsPage(false);
      setIsModalVisible(false);
      dispatch(employees({ checkers: checker }));
      dispatch({
        type: AddEmployees.RESET,
      });
    } else if (status === false) {
      if (errors) {
        dispatch({
          type: AddEmployees.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addEmployeesResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = deleteEmployeesResponse;
    if (status) {
      clearState();
      setSelectedId("");
      setShowAddPage(false);
      setShowDetailsPage(false);
      setIsModalVisible(false);
      dispatch(employees({ checkers: checker }));
      dispatch({
        type: DeleteEmployees.RESET,
      });
    } else if (status === false) {
      dispatch({
        type: DeleteEmployees.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteEmployeesResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateEmployeesResponse;
    if (status) {
      setSelectedId("");
      setShowAddPage(false);
      setShowDetailsPage(false);
      setIsModalVisible(false);
      dispatch(employees({ checkers: checker }));
      dispatch({
        type: UpdateEmployees.RESET,
      });
    } else if (status === false) {
      dispatch({
        type: UpdateEmployees.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEmployeesResponse]);

  const handleAdd = () => {
    setSelectedId("");
    setShowAddPage(!showAddPage);
    setShowDetailsPage(false);
    dispatch(getCustomFields({ is_enable: true }));
  };

  const handleTransfer = () => {
    setTransfer(true);
  };

  const clearState = () => {
    setTransfer(false);
    setAssignee(false);
    setEmpId("");
  };

  const handleApprover = (value) => {
    setEmpId(value);
  };

  const handleAssign = () => {
    setAssignee(true);
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    clearState();
    setIsModalVisible(false);
  };

  const showEditModal = (id) => {
    setSelectedId(id);
    dispatch(getCustomFields({ employee_id: id }));
    setShowAddPage(true);
  };

  const handleRowClick = (evt, record) => {
    evt.preventDefault();
    if (record) {
      setClickedRecord(record.id);
    }
    setShowDetailsPage(!showDetailsPage);
  };

  const renderDeleteOption = () => {
    return (
      <>
        {checker ? (
          <Text>Are you sure you want to delete user ?</Text>
        ) : (
          <>
            <Text>
              Employee Expenses and Expense Reports will still be in the data
              base to view but employee will be deleted and no longer will
              access the system.
            </Text>
            <br /> <br />
            <Checkbox
              className="checkboxes"
              // value={assignee}
              checked={assignee}
              onChange={handleAssign}
            >
              Assign employees assigned to this user to another approver
            </Checkbox>
            {sum > 0 ? (
              <Checkbox
                className="checkboxes"
                onChange={handleTransfer}
                checked={transfer}
                //value = {transfer}
                style={{ marginTop: 20, marginLeft: 2 }}
              >
                Transfer pending approvals with this user to the new user
              </Checkbox>
            ) : (
              ""
            )}
            <br />
            <br />
            {/* <Text className="mb1 lightText">
          Permanently deletes the user information, expenses, reports, chats,
          and everything.
    </Text>*/}
            <Select
              onChange={handleApprover}
              options={data}
              style={{ width: 200 }}
              value={empId}
            ></Select>
          </>
        )}
        <br />
        <br />
        <Button
          key="1"
          className="formButton"
          onClick={() =>
            dispatch(
              deleteEmployees(
                objectToFormData({
                  id: selectedId,
                  status: "deleted",
                  approver_id: empId,
                  transfer_pending_approvals: transfer,
                  assign_approver: assignee,
                  is_corporate_checker: checker,
                }),
              ),
            )
          }
          disabled={deleteEmployeesResponse?.loading}
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  const handleEvents = (value) => {
    dispatch(employees({ search: value, checkers: checker }));
    setSearch(value);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="1" icon={<PlusCircleOutlined />}>
        Add New User
      </Menu.Item>
      <Menu.Item key="2" icon={<UploadOutlined />}>
        Upload Users
      </Menu.Item>
    </Menu>
  );

  // function handleButtonClick(e) {
  //   showModal();
  // }

  function handleMenuClick(e) {
    if (e.key === "1") handleAdd();
    else history.push("/upload-bulk-users");
  }

  return (
    <>
      <Modal
        title="Delete User"
        visible={isModalVisible}
        onCancel={handleCancel}
        onClose={clearState}
        footer={[]}
        className="center-aligned-modal"
      >
        {renderDeleteOption()}
      </Modal>
      {showAddPage ? (
        checker ? (
          <AddCorporateForm
            selectedId={selectedId}
            user={location.state?.user}
            handleAdd={handleAdd}
          />
        ) : (
          <AddUsers
            handleAdd={handleAdd}
            selectedId={selectedId}
            user={location.state?.user}
          />
        )
      ) : showDetailsPage ? (
        <UserDetails
          handleRowClick={handleRowClick}
          showEditModal={showEditModal}
          showDeleteModal={showDeleteModal}
          selectedRecord={clickedRecord}
          checker={checker}
        />
      ) : (
        <>
          <div className="heading-div">
            <PageHeader
              title={checker ? `Corporate Checkers` : `Users`}
              navigation={{
                Home: "/dashboard/",

                Users: null,
              }}
            />
          </div>
          <Card
            className="settingCard"
            bordered={false}
            extra={
              <>
                <div className="buttonsLeft">
                  {/* <Button className="filterButtons active">All Users</Button> */}
                  {/* <Button className="ml1 filterButtons">
                    Users with Cards
                  </Button>
                  <Button className="ml1 filterButtons">
                    Users without Cards
                  </Button>
                  <Button className="ml1 filterButtons">&gt;</Button> */}
                </div>
                <div className="buttonsRight">
                  <Search
                    placeholder={
                      checker
                        ? "Search by Name, Email"
                        : "Search by ID, Name, Email"
                    }
                    className="ml1 searchBox"
                    style={{ width: 200 }}
                    onSearch={handleEvents}
                    onChange={(e) => {
                      if (searchRef.current) {
                        clearTimeout(searchRef.current);
                      }
                      searchRef.current = setTimeout(() => {
                        handleEvents(e.target.value.trimStart());
                      }, 500);
                    }}
                  />
                  {hasAccess("users_and_controls", "write") &&
                    (checker ? (
                      <Button
                        onClick={handleAdd}
                        className="mb1 ml1 addNew primaryButton"
                      >
                        <img
                          src={AddNewIcon}
                          alt={"logo"}
                          className="addNew-logo"
                        />
                        Add New
                      </Button>
                    ) : (
                      <Dropdown.Button
                        onClick={handleAdd}
                        className="mb1 ml1 addNew primaryButton"
                        overlay={menu}
                        icon={<CaretDownOutlined style={{ color: "#fff" }} />}
                      >
                        <img
                          src={AddNewIcon}
                          alt={"logo"}
                          className="addNew-logo"
                        />
                        Add New
                      </Dropdown.Button>
                    ))}
                </div>
              </>
            }
          >
            <Table
              scroll={{ x: 1400 }}
              onRow={(record) => {
                return {
                  onClick: (event) => handleRowClick(event, record),
                };
              }}
              pagination={{
                total: total_records || 0,
                onChange: (pagee) =>
                  dispatch(
                    employees({ page: pagee, search, checkers: checker }),
                  ),
              }}
              columns={[...columns.filter((ele) => ele), ...tableAction]}
              dataSource={employeesData}
              className="settingsTable cursor"
            />
          </Card>
        </>
      )}
    </>
  );
};

export default Users;
